<template>
    <div class="mock_center">
        <!-- <div class="banner inner">
            <img v-if="$store.state.user.banner.banner2" style="width:100%;" :src="$store.state.user.banner.banner2" alt="banner">
        </div> -->
        <secondary-banner title="考核习题库"></secondary-banner>
        <div class="content">
            <div class="inner">
                <div class="relevant">
                    <app-synopsis-title class="app_title">模拟正式考试,考前针对性训练</app-synopsis-title>
                    <div class="sub_title">模拟练习相结合，无限刷题学习，巩固错题</div>
                    <div class="relevant_cont">
                        <div class="rel_item" v-for="(item,index) in mockData" :key="index">
                            <div class="rel_title">{{item.title}}</div>
                            <div class="rel_txt">{{item.content}}</div>
                        </div>
                    </div>
                </div>
                <div class="relevant">
                    <app-synopsis-title class="app_title">功能特色</app-synopsis-title>
                    <div class="sub_title">多样化模拟考试模式，让线上考试更丰富</div>
                    <div class="relevant_cont2">
                        <div class="characteristic" v-for="(item,index) in characteristic" :key="index">
                            <div class="item rel_left">
                                <img :src="item.image" alt="">
                            </div>
                            <div class="item rel_right">
                                <div class="rel_title">{{item.title}}</div>
                                <div class="rel_txt" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppSynopsisTitle from '@/components/AppSynopsisTitle'
import AppSynopsisSubTitle from '@/components/AppSynopsisSubTitle'
import SecondaryBanner from "@/components/SecondaryBanner"
export default {
    name:'MockCenter',
    components:{
        AppSynopsisTitle,
        AppSynopsisSubTitle,
        SecondaryBanner
    },
    data(){
        return {
            mockData:[{
                title:'高真模拟考试',
                content:'高度还原正式考试的要求，考前进行模拟练习，满足线下考试的模拟考试，具有针对性的错题演练，考生可以自主学习刷题练习'
            },{
                title:'批量练习刷题',
                content:'顺序练习，背题练习，全方位针对考题进行反复训练，实时显示题目对错和正确答案，针对学科更扎实的巩固。'
            },{
                title:'错题巩固训练',
                content:'错题收集更准确的了解知识的薄弱点，记录错题到错题收藏库，反复针对错题进行巩固练习，更针对性指定复习计划。'
            }],
            characteristic:[{
                image:require('../assets/images/characteristic1.png'),
                title:'丰富的考试场景',
                content:'模拟考试，考前练习刷题，针对不同需要配置不同考试模式<br>错题收藏，方便每次模拟考试后及时查漏补缺<br>两种练习模式相结合，顺序，背题模式选择'
            },{
                image:require('../assets/images/characteristic2.png'),
                title:'反复训练无限制刷题',
                content:'题库内有上千道题目，合理规整考题分类<br>题库录入分类分组，满足不同专业的模拟考试练习<br>模拟考试平台无限制刷题，针对错题进行仿真考试'
            },{
                image:require('../assets/images/characteristic3.png'),
                title:'移动端支持随时随地模拟考试',
                content:'手机练习无视场所限制无需下载更多软件，平台练习更便捷<br>考后智能批卷，模拟考试结束后立即出成绩，实时查漏补缺<br>模拟考试会详细记录往期考试成绩，合格次数，'
            },]
        }
    }
}
</script>
<style lang="scss" scoped>
.mock_center{
    background: #fff;
    padding-bottom:113px;
}
.relevant{
    margin-top: 100px;
    .app_title{
        margin-bottom: 20px;
    }
    .sub_title{
        font-size: 20px;
        font-weight: bold;
        color: #999999;
        margin-bottom: 40px;
        text-align: center;
    }
    .relevant_cont{
        display: flex;
        justify-content: space-between;
        .rel_item{
            width: 30%;
            background: #F1F1F1;
            border-radius: 10px;
            padding: 37px 13px 16px;
            .rel_title{
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                position: relative;
                margin-bottom: 35px;
                &::after{
                    content: ' ';
                    position: absolute;
                    bottom: -16px;
                    left: 0;
                    width: 41px;
                    height: 5px;
                    background: #3964E6;
                    border-radius: 3px;
                }
            }
            .rel_txt{
                font-size: 15px;
                font-weight: bold;
                color: #999999;
                line-height: 1.5;
            }
        }
    }
    .characteristic{
        display: flex;
        align-items: center;
        .item{
            width: 50%;
        }
        
        &:nth-child(even){
            flex-direction: row-reverse;
            margin: 35px 0;
        } 
        &:nth-child(odd){
            .item{
                padding-left: 30px;
            }
        } 
        .rel_right{
            .rel_title{
                font-size: 30px;
                font-weight: bold;
                color: #3964E6;
                position: relative;
                margin-bottom: 58px;
                &::after{
                    content: ' ';
                    position: absolute;
                    width: 100px;
                    height: 3px;
                    background: #3964E6;
                    left: 0;
                    bottom: -30px;
                }
            }
        }
        .rel_txt{
            font-size: 20px;
            font-weight: bold;
            color: #999999;
            line-height: 1.5;
        }
    }
}
</style>